export const TOOLTIP_INFO = 'TOOLTIP_INFO';
export const TOOLTIP_WARNING = 'TOOLTIP_WARNING';
export const TOOLTIP_ERROR = 'TOOLTIP_ERROR';

export const TOOLTIP_ICON_LOCK = 'fa-lock';
export const TOOLTIP_ICON_INFO = 'fa-info-circle';
export const TOOLTIP_ICON_EXCLAMATION_TRIANGLE = 'fa-exclamation-triangle';

export const COLOR_RED = 'red';
export const COLOR_BLUE = 'blue';
export const COLOR_YELLOW = 'yellow';
export const COLOR_GREEN = 'green';
export const COLOR_PURPLE = 'purple';
export const COLOR_PINK = 'pink';
export const COLOR_ORANGE = 'orange';
export const COLOR_TURQUOISE = 'turquoise';
export const COLOR_PINK_LIGHT = 'pink-light';
export const COLOR_GREEN_LIGHT = 'green-light';
export const COLOR_TURQUOISE_DARK = 'turquoise-dark';
export const COLOR_CORAL = 'coral';
export const COLOR_MINT = 'mint';
export const COLOR_TURQUOISE_DARK_HEX = '#033e51';
export const COLOR_BLUE_DARK = 'dark-blue';
export const COLOR_BLUE_LIGHT_HEX = '#39b4e8';
export const COLOR_WHITE = 'white';
export const COLOR_BLACK = 'black';
export const COLOR_GRAY_LIGHT = 'gray-light';
export const COLOR_GRAY = 'gray';

export const ColorArray = [
	COLOR_RED,
	COLOR_PURPLE,
	COLOR_BLACK,
	COLOR_TURQUOISE_DARK_HEX,
	COLOR_ORANGE,
	COLOR_GREEN
];

export const ConflictColorArray = [
	COLOR_BLACK,
	COLOR_ORANGE,
	COLOR_GREEN,
	COLOR_PINK,
	COLOR_YELLOW,
	COLOR_BLUE,
	COLOR_PURPLE,
];

export const FONT_ICON_EXCLAMATION = 'fa-exclamation';

export const AUTOCOMPLETE_NO_RESULTS_LETTERS = 'Typ (2 letters) en zoek';
export const AUTOCOMPLETE_NO_RESULTS_CIJFERS = 'Typ (2 cijfers) en zoek';

export const TRANSPARENT_PIXEL_PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';

export const ICON_STATUS = 'ICON_STATUS';
export const ICON_ORGANISATOR = 'ICON_ORGANISATOR';
export const ICON_VELDTOERTOCHT = 'ICON_VELDTOERTOCHT';
export const ICON_CYCLOTOCHT = 'ICON_CYCLOTOCHT';
export const ICON_PUBLICATIE = 'ICON_PUBLICATIE';
export const ICON_LUSSEN = 'ICON_LUSSEN';
export const ICON_AFSTANDEN = 'ICON_AFSTANDEN';
export const ICON_TOELATINGEN = 'ICON_TOELATINGEN';
export const ICON_SAMENVATTING = 'ICON_SAMENVATTING';
export const ICON_TERUGNAAROVERZICHT = 'ICON_TERUGNAAROVERZICHT';

export const AFSTAND_TEKST = 'afstand/route';
export const AFSTANDEN_TEKST = 'afstanden';
export const LUS_TEKST = 'lus';
export const LUSSEN_TEKST = 'lussen';

export const AFWACHTING_FEDERATIE_OVERKOEPELENDE_ACTOR = 'In afwachting van behandeling door federatie/overkoepelende actor';
export const AFGEKEURD_FEDERATIE_OVERKOEPELENDE_ACTOR = 'Afgekeurd door federatie/overkoepelende actor';
export const AFWACHTING_SPORT_VLAANDEREN = 'In afwachting van behandeling door Sport Vlaanderen';
export const DOSSIER_ONVOLLEDIG = 'Dossier onvolledig';
export const DOSSIER_VOLLEDIG = 'Dossier volledig';
export const DOORGESTUURD_TER_GOEDKEURING = 'Doorgestuurd ter goedkeuring';
export const WACHT_OP_AANVULLING_DOOR_ORGANISATOR = 'Wacht op aanvulling door organisator.';

export const STATUS_TOOLTIP_AFWACHTING_FEDKOEPEL = 'De federatie moet deze tocht eerst goedkeuren alvorens deze verder kan verwerkt worden. Je kan intussen de gegevens van je tocht al verder aanvullen.';
export const STATUS_TOOLTIP_AFWACHTING_SVL_CONTROLE = 'Sport Vlaanderen controleert of de routes van deze tocht in conflict zijn met andere tochten.';
export const STATUS_TOOLTIP_WACHT_OP_AANVULLING = 'Zorg ervoor dat er bij elke lus een GPX opgeladen is en dat in geval van een conflict de GPX aangepast wordt.';
export const STATUS_TOOLTIP_DOSSIER_ONVOLLEDIG = 'Vul je tocht verder aan.';
export const STATUS_TOOLTIP_DOSSIER_VOLLEDIG = 'Geen actie nodig. De tocht wordt automatisch ter goedkeuring doorgestuurd naar de bevoegde instanties. Dit gebeurt vanaf 1 jaar voor de organisatiedatum.';
export const STATUS_TOOLTIP_DOORGESTUURD_TER_GOEDKEURING = 'De bevoegde instanties kunnen nu je tocht beoordelen. In de sectie "Goedkeuringen" van je tocht vind je de beoordelingen. Wanneer de status van een goedkeuring onbeslist blijft, neem je contact op met de betrokken instantie.';

export const TOOLTIP_GEPUBLICEERDE_TOCHT_ANNULEREN = 'Om deze tocht te annuleren moet je eerst op de tab Publicatie aanduiden dat deze tocht niet meer mag gepubliceerd worden bij UiT in Vlaanderen en Sport Vlaanderen. Daarna kan de tocht geannuleerd worden.';
export const TOOLTIP_GEEN_PDF_BESCHIKBAAR = 'Geen PDF beschikbaar. Open je tocht en genereer de PDF op de tab Samenvatting.';

export const DEFAULT_MIME_TYPES = ''.concat(
	'application/pdf,',
	'application/vnd.ms-excel,',
	'application/msexcel,',
	'application/x-excel,',
	'application/x-msexcel,',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,',
	'application/msword,',
	'application/vnd.ms-word,',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document,',
	'application/mspowerpoint,',
	'application/vnd.ms-powerpoint,',
	'application/x-mspowerpoint,',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation,',
	'image/jpeg,',
	'image/gif,',
	'image/png,',
	'image/tiff,'
);

export const FileComponentNames = {
	DEMO: "demo_component",
	SJABLOON_DEMO: "sjabloon_demo",
	BEWIJS_VAN_VERZEKERING: "bewijs_van_verzekering",
	BEWIJSSTUKKEN_TOELATING_: "bewijsstukken_toelating_",
	GEWIJZIGDE_GPX: "gewijzigde_gpx",
	MACHTIGING_ANB: "machtiging_anb",
	GPX_BESTAND: "gpx_bestand",
	FOTOS_PIJLEN: "fotos_pijlen",
	UIVFOTO: "uivfoto",
	DRAAIBOEK_CORONA_MAATREGELEN: "draaiboek_corona_maatregelen"
};

export const ValidationMessageTypes = {
	ERROR: "error",
	WARNING: "warning"
};

export const GeoJsonFeatures = {
	BEVOORRADINGSZONE: 'bevoorradingsZone'
};

export const DEFAULT_FILE_EXTENSIONS = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';

export const EditBevoorradingsZonesStatus = Object.freeze({
	EDITING: 1,
	ADDING: 2,
	REMOVING: 3
});
